import { render } from "./SvgComponents.vue?vue&type=template&id=7281c49e"
import script from "./SvgComponents.vue?vue&type=script&lang=js"
export * from "./SvgComponents.vue?vue&type=script&lang=js"

import "./SvgComponents.vue?vue&type=style&index=0&id=7281c49e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__